import React from 'react';
import BubbleButton, { BubbleButtonProps } from './BubbleButton';

interface BubbleNavItem {
  name: string;
  active: boolean;
  to?: string; // only used if not active
  hide?: boolean; // only used if not active
  variant?: BubbleButtonProps['variant'];
}

interface BubbleNavigationProps {
  items: BubbleNavItem[];
  appearance?: 'triangular' | 'squared';
}

export default function BubbleNavigation({
  items,
  appearance = 'triangular',
}: BubbleNavigationProps) {
  const filteredItems = items.filter(itm => itm.active || !itm.hide);

  const processedItems = filteredItems.map((itm, i) => ({
    ...itm,
    _isLastEl: i === filteredItems.length - 1,
  }));

  const classes: string[] = [];

  if (appearance === 'triangular') classes.push('text-base-i w-48 pl-5-i text-left space-x-3');
  else classes.push('w-full');

  return (
    <>
      {processedItems.map(itm => (
        <BubbleButton
          key={itm.name}
          appearance={appearance}
          variant={itm.active ? itm.variant || 'navy' : 'smoke'}
          className={[
            ...classes,
            !itm.active ? 'font-normal-i' : '',
            !itm._isLastEl && appearance === 'triangular' ? 'mr-3' : '',
          ].join(' ')}
          linkProps={!itm.active && itm.to ? { to: itm.to } : undefined}
        >
          {itm.name}
        </BubbleButton>
      ))}
    </>
  );
}
